export const priorityTypes = [
  { label: 'Business', value: 'Business' },
  { label: 'Star', value: 'Star' }
  // { label: 'Zone', value: 'Zone' }
];
